export default __webpack_public_path__ + "static/media/back.40a842ae.jpg";